// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"250":"9ef1f2c4","982":"9ef1f2c4"}[chunkId] + ".chunk.css";
};